export default __webpack_public_path__ + "static/media/loader-logo-modified.c65c3a0e.png";